import { render } from "./_404.vue?vue&type=template&id=18cabea1&scoped=true"
import script from "./_404.vue?vue&type=script&lang=js"
export * from "./_404.vue?vue&type=script&lang=js"

import "./_404.vue?vue&type=style&index=0&id=18cabea1&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18cabea1"]])

export default __exports__